import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Paragraph,
    Button,
    Spacer,
    Flex,
    TextButton,
} from '@zillow/constellation';
import { Center, Row, Col } from '@zillow/zrs-comet';

import { GA_EVENTS } from 'app/shared/constants/AnalyticsLeasesModuleConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';

import SvgHandshake from './Handshake';


import {
    ConnectedLeaseContainer,
    StyledCard,
    StyledCenter,
    StyledCtaCol,
} from './StyledComponents';

const {
    GET_STARTED_EMPTY_STATE_CLICK,
    LEARN_MORE_EMPTY_STATE_CLICK,
} = GA_EVENTS;

const EmptyLeasesCard = ({
    title,
    description,
    primaryCtaText,
    primaryCtaUrl,
    secondaryCtaText,
    secondaryCtaUrl,
}) => {
    const dispatch = useDispatch();

    const handleEmptyLeasesCardPrimaryCTAClick = () => {
        dispatch(analyticsUtils.track.GAEventV2(GET_STARTED_EMPTY_STATE_CLICK));
    };

    const handleEmptyLeasesCardSecondaryCTAClick = () => {
        dispatch(analyticsUtils.track.GAEventV2(LEARN_MORE_EMPTY_STATE_CLICK));
    };

    return (
        <ConnectedLeaseContainer className="EmptyLeasesCard">
            <StyledCard isDisabled={true} data-test="empty-leases-card">
                <Row>
                    <Col xs={12} md={2} lg={12} alignVertical="center">
                        <Spacer paddingTop="xs" paddingBottom="sm">
                            <Center>
                                <SvgHandshake />
                            </Center>
                        </Spacer>
                    </Col>
                    <Col xs={12} md={6} lg={12} alignVertical="center">
                        <StyledCenter>
                            <Paragraph fontType="bodyHeading">{title}</Paragraph>
                            <Paragraph fontType="bodySmall" paddingTop="sm">{description}</Paragraph>
                        </StyledCenter>
                    </Col>
                    <StyledCtaCol
                        xs={12}
                        md={3}
                        lg={12}
                        offset={{
                            md: 1,
                            lg: 0,
                        }}
                        alignVertical="center"
                    >
                        <Flex display="flex" flexDirection="column">
                            {
                                (secondaryCtaText && secondaryCtaUrl) && (
                                    <Flex
                                        mediaQuery={{
                                            xs: { order: 0 },
                                            md: { order: 1 },
                                            lg: { order: 0 },
                                        }}
                                        flex="1"
                                    >
                                        <Center
                                            marginBottom="xs"
                                            mediaQuery={{
                                                xs: { order: 0 },
                                                md: { order: 1 },
                                                lg: { order: 0 },
                                            }}
                                            flex="1"
                                        >
                                            <TextButton
                                                paddingY="xs"
                                                as="a"
                                                data-test="empty-leases-card-default-anchor"
                                                href={secondaryCtaUrl}
                                                fluid={true}
                                                onClick={handleEmptyLeasesCardSecondaryCTAClick}
                                            >
                                                {secondaryCtaText}
                                            </TextButton>
                                        </Center>
                                    </Flex>
                                )
                            }
                            <Flex flex="1">
                                <Spacer paddingTop={(secondaryCtaText && secondaryCtaUrl) ? 0 : 'md'}>
                                    <Button
                                        as="a"
                                        href={primaryCtaUrl}
                                        buttonType="primary"
                                        fluid={true}
                                        onClick={handleEmptyLeasesCardPrimaryCTAClick}
                                    >
                                        {primaryCtaText}
                                    </Button>
                                </Spacer>
                            </Flex>
                        </Flex>
                    </StyledCtaCol>
                </Row>
            </StyledCard>
        </ConnectedLeaseContainer>
    );
};

EmptyLeasesCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    primaryCtaText: PropTypes.string.isRequired,
    primaryCtaUrl: PropTypes.string.isRequired,
    secondaryCtaText: PropTypes.string,
    secondaryCtaUrl: PropTypes.string,
};

EmptyLeasesCard.defaultProps = {
    secondaryCtaText: '',
    secondaryCtaUrl: '',
};

export default EmptyLeasesCard;
